<template>
  <div :style="{ position: 'relative', height: height + 'px' }">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "viz-chart",
  // type: "bar" | "line" | "pie" | "doughnut"; data/options: Chart.js config objects.
  props: {
    type: { type: String, default: "bar" },
    data: { type: Object, required: true },
    options: { type: Object, default: () => ({}) },
    // Optional per-chart inline plugins and canvas height; the defaults leave
    // every existing caller exactly as it was.
    plugins: { type: Array, default: () => [] },
    height: { type: Number, default: 320 },
  },
  data() {
    return { chart: null };
  },
  watch: {
    data: { handler() { this.render(); }, deep: true },
    type() { this.render(); },
  },
  methods: {
    render() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      if (!this.$refs.canvas) return;
      this.chart = new Chart(this.$refs.canvas, {
        type: this.type,
        data: this.data,
        plugins: this.plugins,
        options: Object.assign({ responsive: true, maintainAspectRatio: false }, this.options),
      });
    },
  },
  mounted() {
    this.render();
  },
  beforeDestroy() {
    if (this.chart) this.chart.destroy();
  },
};
</script>
